import { Header } from '@/components/header/Header';
import Footer from '@/components/footer/Footer';
import RootWrapper from '@/lib/_components/RootWrapper';
import React, { ReactNode } from 'react';
import { cn } from '@/lib/_utils/cn';
import GtmPageViewComponent, { GtmEventTrackingProps } from '@/lib/_components/GtmEventTracking';

const global: Record<'bg_square', string> = {
	bg_square: "bg-[url('/app/auth/auth-bg.svg')] [background-size:calc(max(100%,2732px))] bg-center bg-fixed",
};

export type LayoutType = {
	style?: { global?: 'bg_square' };
	children: ReactNode;
	fullscreen?: boolean;
	responsive?: boolean;
	headerChildren?: ReactNode;
	layoutProps?: JSX.IntrinsicElements['div'];
	mainProps?: JSX.IntrinsicElements['main'];
	gtmEventTrackingProps?: GtmEventTrackingProps;
};

export default function Layout({ ...props }: LayoutType) {
	const { style, children, fullscreen, responsive, headerChildren, layoutProps, mainProps, gtmEventTrackingProps } =
		props;
	const fullscreenClass = fullscreen ? 'h-screen' : 'min-h-screen';
	const responsiveClass = responsive ? 'min-w-full' : 'min-w-[1280px]';
	const bgClass = style?.global && (style?.global as 'bg_square') ? global[style?.global] : '';
	const { className: layoutPropsClassName = '', ...restLayoutProps } = layoutProps || {};

	return (
		<>
			<RootWrapper gtmEventTrackingProps={gtmEventTrackingProps}>
				<div
					className={`${cn('flex w-full flex-1 flex-col', fullscreenClass, responsiveClass, bgClass, layoutPropsClassName)}`}
					{...restLayoutProps}>
					<Header>{headerChildren}</Header>
					<main className={`h-0 flex-1`} {...mainProps}>
						{children}
					</main>
					<Footer />
				</div>
			</RootWrapper>
		</>
	);
}
